export default {"src":"/_next/static/media/cook-with-large-green-chat-box.90d0a612.svg","height":378,"width":301};